import { SuiteSankeyData } from './types'
import FileSaver from 'file-saver'
import { ApplySaveJSONDialog } from 'open-sankey/dist/SankeyMenuDialogs'
import { TFunction } from 'i18next'



type SankeyDialogeSaveJSONTypes = {
  data: SuiteSankeyData,
  set_data: (d:SuiteSankeyData)=>void,
  show_save_json: boolean,
  set_show_save_json: (b:boolean)=>void,

  t:TFunction
}


export const SankeySuiteDialogSaveJSON = ({data,set_data,show_save_json,set_show_save_json,t}:SankeyDialogeSaveJSONTypes)=>{

    

    return <ApplySaveJSONDialog
        t={t}
        show_save_json={show_save_json}
        set_show_save_json={set_show_save_json}
        sankey_data={data}
        set_sankey_data={set_data}
    />


}



